const optimizablePublicImagePattern =
  /^\/(?:case-details|case-images|knowledge-assets|news-assets|platform-logos)\/.+\.(png|jpe?g)$/i;

export const isOptimizablePublicImage = (src?: string | null) =>
  Boolean(src && optimizablePublicImagePattern.test(src));

export const getOptimizedPublicImageSrc = (src?: string | null) => {
  if (!src || !isOptimizablePublicImage(src)) return src || '';
  return `/optimized${src}.webp`;
};

const ensureAttribute = (attributes: string, name: string, value: string) => {
  const pattern = new RegExp(`\\b${name}\\s*=`, 'i');
  return pattern.test(attributes) ? attributes : `${attributes} ${name}="${value}"`;
};

export const optimizeArticleHtmlImages = (html = '') =>
  html.replace(
    /<img\b([^>]*?)\bsrc=(["'])(\/[^"']+\.(?:png|jpe?g|svg))\2([^>]*)>/gi,
    (_match, beforeSrc, _quote, src, afterSrc) => {
      const finalSrc = getOptimizedPublicImageSrc(src) || src;
      let attributes = `${beforeSrc || ''} src="${finalSrc}"${afterSrc || ''}`.trim();
      attributes = ensureAttribute(attributes, 'loading', 'lazy');
      attributes = ensureAttribute(attributes, 'decoding', 'async');
      return `<img ${attributes}>`;
    },
  );
